import styled from 'foundations-theming/utils';
import { useCallback } from 'react';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { AbstractSlider } from 'foundations-components/transitional/components/AbstractSlider';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { VerticalMenuIcon } from 'foundations-assets/icons/components/VerticalMenuIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const HANDLE_TYPE = {
  FROM: 'from',
  TO: 'to'
};
const StyledDragHandle = styled.div.withConfig({
  displayName: "Slider__StyledDragHandle"
})(["position:absolute;top:0;left:calc( ", "% - ", "px );width:7px;height:100%;line-height:100%;background:", ";border:1px ", " solid;border-radius:", ";cursor:ew-resize;z-index:10;user-select:none;"], ({
  value,
  trackLength
}) => value / trackLength * 100, ({
  handleType
}) => handleType === HANDLE_TYPE.FROM ? 7 : 1, ({
  theme
}) => theme.color['fill-accent-neutral-subtle-alt'], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.borderRadius['200']);
const Slider = ({
  value,
  trackStart,
  trackEnd,
  onDrag,
  onMouseUp,
  handleType,
  minValue = trackStart,
  maxValue = trackEnd,
  dataUnitTest = 'slider',
  dataAcceptanceTest = 'slider'
}) => {
  const handleMouseMove = useCallback(evt => {
    evt.stopPropagation();
    const newValuePositionX = evt.clientX;
    onDrag(newValuePositionX);
  }, [onDrag]);
  const handleMouseUp = useCallback(evt => {
    evt.stopPropagation();
    if (onMouseUp) {
      const newValuePositionX = evt.clientX;
      onMouseUp(newValuePositionX);
    }
    window.removeEventListener('mouseup', handleMouseUp);
    window.removeEventListener('mousemove', handleMouseMove);
  }, [onMouseUp, handleMouseMove]);
  const handleMouseDown = useCallback(evt => {
    evt.stopPropagation();
    window.addEventListener('mouseup', handleMouseUp, false);
    window.addEventListener('mousemove', handleMouseMove, false);
  }, [handleMouseUp, handleMouseMove]);
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "sliderContainer",
    onMouseDown: handleMouseDown,
    position: "absolute",
    insetBlockStart: "0",
    blockSize: "28px",
    inlineSize: "100%",
    cursor: "grab",
    children: /*#__PURE__*/_jsx(AbstractSlider, {
      "aria-valuemax": maxValue,
      "aria-valuemin": minValue,
      "aria-valuenow": value || 0,
      "aria-valuetext": "slider",
      role: "slider",
      tabIndex: 0,
      "data-test-id": dataUnitTest,
      "data-acceptance-test": dataAcceptanceTest,
      children: /*#__PURE__*/_jsx(StyledDragHandle, {
        "data-test-id": "slider-drag-handle",
        value: value,
        trackLength: trackEnd - trackStart,
        handleType: handleType,
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          blockSize: "100%",
          children: /*#__PURE__*/_jsx(IconHolder, {
            icon: VerticalMenuIcon,
            size: "100",
            color: "icon-core-subtle",
            padding: "0"
          })
        })
      })
    })
  });
};
export default Slider;